var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPassword = function SvgPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.516 8.5a.625.625 0 0 1-.625-.625V6.086a3.171 3.171 0 0 0-3.167-3.168h-.014c-.844 0-1.634.325-2.232.918a3.14 3.14 0 0 0-.937 2.236v1.803a.625.625 0 0 1-1.25 0V6.086c.005-1.2.469-2.308 1.306-3.138.839-.83 1.945-1.311 3.13-1.28a4.422 4.422 0 0 1 4.414 4.418v1.79c0 .344-.28.624-.625.624Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.532 8.44a2.537 2.537 0 0 0-2.535 2.535v3.575a2.537 2.537 0 0 0 2.535 2.535H13.9a2.538 2.538 0 0 0 2.535-2.535v-3.575A2.538 2.538 0 0 0 13.9 8.44H7.532Zm6.368 9.895H7.532a3.789 3.789 0 0 1-3.785-3.785v-3.575A3.789 3.789 0 0 1 7.532 7.19H13.9a3.789 3.789 0 0 1 3.785 3.785v3.575a3.789 3.789 0 0 1-3.785 3.785Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.716 14.313a.625.625 0 0 1-.625-.625v-1.851a.625.625 0 0 1 1.25 0v1.85c0 .346-.28.626-.625.626Z"
  }))));
};
export default SvgPassword;